// Domain classification for identifier-first login (ADR-015).
// Seeded 2026-08-27 from live Users emails + MX +
// GET https://www.google.com/a/<domain>/ServiceLogin
// (302 SAML / 200 "Sign in - Google Accounts" / 200 "Server error").
// Do not call that probe at request time — rerun scripts/auth/google-domain-report.sh
// when new institutional domains appear, then extend these sets.

/** Consumer Gmail — Google login, never pass `hd`. */
export const GOOGLE_CONSUMER_DOMAINS = new Set(["gmail.com", "googlemail.com"]);

/** Google Workspace hosts verified by the 2026-08-27 probe. Pass `hd=<domain>`. */
export const GOOGLE_WORKSPACE_DOMAINS = new Set([
  "berkeley.edu",
  "uct.ac.za",
  "aau.edu.et",
  "ibab.ac.in",
  "facmed.unam.mx",
  "knowledgefutures.org",
]);

/** Known-not-Google (Microsoft 365 / other). Always email-link. */
export const NOT_GOOGLE_LOGIN_DOMAINS = new Set(["vinuni.edu.vn"]);

export type LoginMethod = "google" | "email-link";

export function emailDomain(email: string): string | null {
  const trimmed = email.trim().toLowerCase();
  const at = trimmed.lastIndexOf("@");
  if (at < 1 || at === trimmed.length - 1) return null;
  return trimmed.slice(at + 1);
}

export function isGoogleLoginDomain(email: string): boolean {
  const domain = emailDomain(email);
  if (!domain) return false;
  if (NOT_GOOGLE_LOGIN_DOMAINS.has(domain)) return false;
  return GOOGLE_CONSUMER_DOMAINS.has(domain) || GOOGLE_WORKSPACE_DOMAINS.has(domain);
}

/** Workspace `hd` value for the OAuth URL, or undefined for Gmail / unknown. */
export function hostedDomainForOAuth(email: string): string | undefined {
  const domain = emailDomain(email);
  if (!domain || !GOOGLE_WORKSPACE_DOMAINS.has(domain)) return undefined;
  return domain;
}

export function preferredLoginMethod(email: string): LoginMethod {
  return isGoogleLoginDomain(email) ? "google" : "email-link";
}
